import React from "react";
import GoogleAnalytics from "../components/GoogleAnalytics";
import TrackingCode from "../components/TrackingCode";

const SpecialDaySettingsPage = () => {
  return (
    <>
      <TrackingCode />
      <GoogleAnalytics />
      <div>SpecialDaySettingsPage</div>
    </>
  );
};

export default SpecialDaySettingsPage;
